












import { truncate, get } from 'lodash';
import Chart from './Chart';
import 'echarts/lib/chart/bar';
import { SeriesItemProp } from './Visualization';
import { MetricOptions } from '@/constants/DashboardConstants';
import { getDimensionAxisLabel } from '@/utils/DashboardUtils';

export default {
  name: 'VerticalBarChart',
  components: {
    Chart,
  },
  props: {
    series: {
      type: Array as SeriesItemProp[],
      default: [],
    },
    settings: {
      type: Object,
      required: true,
    },
  },
  computed: {
    options() {
      const {
        series,
        settings: { metric },
      } = this;

      const { labels, values } = series.reduce(
        (data, item) => {
          const { label, labelId, value, color } = item;
          data.labels.push(label);
          data.values.push({
            value,
            labelId,
            itemStyle: { color },
          });
          return data;
        },
        { labels: [], values: [] }
      );

      const metricLabel = get(MetricOptions, `${metric}.label`);
      const dimensionLabel = getDimensionAxisLabel(this.settings);

      return {
        grid: {
          show: false,
          bottom: 76,
          left: 46,
          top: 20,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        xAxis: {
          type: 'category',
          data: labels,
          axisLabel: {
            rotate: 45,
            formatter: (value: string) => {
              return truncate(value, {
                length: 10,
                omission: '...',
              });
            },
          },
          name: dimensionLabel,
          nameLocation: 'middle',
          nameGap: 60,
          nameTextStyle: {
            color: '#8c9ba5',
            fontSize: 14,
          },
        },
        yAxis: {
          type: 'value',
          name: `Count of ${metricLabel}`,
          nameLocation: 'middle',
          nameGap: 30,
          minInterval: 1,
          nameTextStyle: {
            color: '#8c9ba5',
            fontSize: 14,
          },
        },
        series: [
          {
            type: 'bar',
            data: values,
          },
        ],
      };
    },
  },
};
